// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const StudioLocation = registerClientReference(
    function() { throw new Error("Attempted to call StudioLocation() from the server but StudioLocation is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/contactpage/ContactSection/StudioLocation.tsx",
    "StudioLocation",
);
